import ApiResourceManager from '../ApiResourceManager';

export default class ProviderBillingLicensesManager extends ApiResourceManager {
  #onBehalf = (serviceProviderId) =>
    serviceProviderId ? { headers: { 'x-on-behalf-of-service-provider': serviceProviderId } } : {};

  /**
   * The paywall's entitlements for one restaurant, read on behalf of a
   * partner — the same payload the partner's own screens get, so a super
   * admin sees exactly what they see.
   */
  entitlements = (companyId, serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: `/provider-licenses/companies/${companyId}/entitlements`,
      ...this.#onBehalf(serviceProviderId),
    });

  /** The partner's companies, each with its licenses (items + next-period preview). */
  index = (serviceProviderId = undefined) =>
    this.request({
      method: 'GET',
      url: '/provider-licenses',
      ...this.#onBehalf(serviceProviderId),
    });

  /**
   * @param data { company_id, items: [{ product_id, quantity }] }
   */
  create = (data, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: '/provider-licenses',
      data,
      ...this.#onBehalf(serviceProviderId),
    });

  /**
   * Full item diff: removed products are closed, new ones get a fresh price
   * snapshot — existing snapshots are never touched.
   */
  updateItems = (licenseId, items, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      url: `/provider-licenses/${licenseId}`,
      data: { items },
      ...this.#onBehalf(serviceProviderId),
    });

  pause = (licenseId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-licenses/${licenseId}/pause`,
      ...this.#onBehalf(serviceProviderId),
    });

  resume = (licenseId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-licenses/${licenseId}/resume`,
      ...this.#onBehalf(serviceProviderId),
    });

  cancel = (licenseId, serviceProviderId = undefined) =>
    this.request({
      method: 'POST',
      url: `/provider-licenses/${licenseId}/cancel`,
      ...this.#onBehalf(serviceProviderId),
    });
}
